/**
 * BOM Extractor API Page
 * 
 * Provides access to the ForwardPath PDF Extractor tool
 * hosted at tools.laframboise.net
 */

import React from 'react';
import { usePresence, ActiveViewers } from '../common/ViewingTemplate';

const BomExtractorApiPage = () => {
  const { viewers, isConnected, connectionState } = usePresence('bomExtractorApi', 'global', true);
  const externalUrl = 'https://tools.laframboise.net';

  const handleOpenExternal = () => {
    window.open(externalUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: 12 }}>
        <h1 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>
          BOM Extractor API
        </h1>
        <ActiveViewers viewers={viewers} isConnected={isConnected} connectionState={connectionState} maxVisible={4} showConnectionStatus={true} />
      </div>
      
      <div style={{ 
        backgroundColor: '#f8f9fa', 
        border: '1px solid #e9ecef', 
        borderRadius: '8px', 
        padding: '24px',
        marginBottom: '24px'
      }}>
        <h2 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '12px' }}>
          PDF Extractor Tool
        </h2>
        <p style={{ color: '#6c757d', marginBottom: '16px' }}>
          The BOM Extractor API is an external tool for extracting Bill of Materials data from PDF documents.
          It uses Azure Document Intelligence and AI to parse PDF tables into structured data.
        </p>
        
        <button
          onClick={handleOpenExternal}
          style={{
            backgroundColor: '#0d6efd',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <span>Open PDF Extractor</span>
          <span style={{ fontSize: '14px' }}>↗</span>
        </button>
      </div>

      <div style={{ 
        backgroundColor: '#fff3cd', 
        border: '1px solid #ffc107', 
        borderRadius: '8px', 
        padding: '16px'
      }}>
        <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#856404', marginBottom: '8px' }}>
          Note
        </h3>
        <p style={{ fontSize: '14px', color: '#856404', margin: 0 }}>
          This tool opens in a new window and requires Microsoft login authentication.
          The extracted data can be exported and imported into the LGL Portal.
        </p>
      </div>

      <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#e7f1ff', borderRadius: '8px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '12px' }}>
          Quick Links
        </h3>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#495057' }}>
          <li style={{ marginBottom: '8px' }}>
            <a href={externalUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd' }}>
              {externalUrl}
            </a>
          </li>
          <li>
            <span>API Endpoint: </span>
            <code style={{ backgroundColor: '#f8f9fa', padding: '2px 6px', borderRadius: '4px' }}>
              https://tools.laframboise.net/api
            </code>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BomExtractorApiPage;
